import { forwardRef } from "react";
import { QRCode } from "antd";
import { formatPosterExpiry } from "../../utils/deliveryPoster";
import { useTranslation } from "../../i18n";
import "./DeliveryPoster.css";

const DeliveryPoster = forwardRef(function DeliveryPoster(
    { albumName, expiresAtLabel, url },
    ref
) {
    const { t } = useTranslation();
    return (
        <div ref={ref} className="delivery-poster">
            <div className="delivery-poster__inner">
                <header className="delivery-poster__header">
                    <div className="delivery-poster__brand">HEI CREATIVE</div>
                    <h1 className="delivery-poster__title">{albumName}</h1>
                    <div className="delivery-poster__subtitle">{t("delivery.share.poster.subtitle")}</div>
                </header>

                <section className="delivery-poster__qr-section">
                    <div className="delivery-poster__qr-wrapper">
                        <div className="delivery-poster__qr-inner">
                            {url ? (
                                <QRCode
                                    value={url}
                                    size={190}
                                    color="#1d1d1f"
                                    bgColor="#ffffff"
                                    bordered={false}
                                    errorLevel="M"
                                />
                            ) : null}
                        </div>
                    </div>
                    <div className="delivery-poster__qr-text">{t("delivery.share.poster.scanHint")}</div>
                </section>

                <footer className="delivery-poster__footer">
                    <div className="delivery-poster__divider" />
                    <div className="delivery-poster__expiry">
                        {t("delivery.share.poster.expiryLabel")} · {formatPosterExpiry(expiresAtLabel)}
                    </div>
                    <div className="delivery-poster__social">
                        <div>小红书 @伦敦摄影师小黑</div>
                        <div>Instagram @Mr.Hei_</div>
                    </div>
                    <div className="delivery-poster__website">HEICREATIVE.CO.UK</div>
                </footer>
            </div>
        </div>
    );
});

export default DeliveryPoster;
